// Wire codec abstraction.
//
// MVP ships JSON only. The interface exists so that a future binary
// codec (MessagePack / custom) can be swapped in without touching
// transport or handler code.
// (protocol.md §7.1 / architecture.md §19.12)
/**
 * JSON codec implementation. Used by MVP transport.
 *
 * Class form (rather than a bare object literal) so that future
 * implementations (`MsgPackCodec`, etc.) can extend / share helpers
 * uniformly via the `Codec` interface.
 */
export class JsonCodec {
    encode(ev) {
        return JSON.stringify(ev);
    }
    decode(data) {
        if (typeof data === 'string') {
            return JSON.parse(data);
        }
        return JSON.parse(new TextDecoder().decode(data));
    }
}
/** Default JSON codec singleton. */
export const jsonCodec = new JsonCodec();
//# sourceMappingURL=codec.js.map